// eslint-disable-next-line import/prefer-default-export
export function toCurrency(amount, locale, currencyLocal) {
	const number = Number(amount)
	const formatter = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: currencyLocal,
		minimumFractionDigits: 2,
	})
	return formatter.format(number)
}
